{
  "brand": {
    "name": "Sigma08",
    "tagline": "Plataforma de Aprendizado com IA",
    "description": "Transforme a educação com experiências de aprendizado personalizadas por IA"
  },
  "actions": {
    "submit": "Enviar",
    "cancel": "Cancelar",
    "save": "Salvar",
    "delete": "Excluir",
    "edit": "Editar",
    "view": "Visualizar",
    "download": "Baixar",
    "upload": "Enviar",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "sort": "Ordenar",
    "refresh": "Atualizar",
    "back": "Voltar",
    "next": "Próximo",
    "previous": "Anterior",
    "close": "Fechar",
    "confirm": "Confirmar",
    "retry": "Tentar novamente",
    "loading": "Carregando...",
    "processing": "Processando..."
  },
  "status": {
    "success": "Sucesso",
    "error": "Erro",
    "warning": "Aviso",
    "info": "Informação",
    "pending": "Pendente",
    "active": "Ativo",
    "inactive": "Inativo",
    "completed": "Concluído",
    "failed": "Falhou",
    "cancelled": "Cancelado"
  },
  "time": {
    "today": "Hoje",
    "yesterday": "Ontem",
    "tomorrow": "Amanhã",
    "thisWeek": "Esta Semana",
    "lastWeek": "Semana Passada",
    "thisMonth": "Este Mês",
    "lastMonth": "Mês Passado",
    "thisYear": "Este Ano",
    "lastYear": "Ano Passado",
    "seconds": "segundos",
    "minutes": "minutos",
    "hours": "horas",
    "days": "dias",
    "weeks": "semanas",
    "months": "meses",
    "years": "anos"
  },
  "pagination": {
    "page": "Página",
    "of": "de",
    "items": "itens",
    "showing": "Mostrando",
    "to": "até",
    "perPage": "Por página",
    "goToPage": "Ir para página"
  },
  "currency": {
    "symbol": "R$",
    "code": "BRL"
  },
  "language": {
    "select": "Selecionar Idioma",
    "current": "Português",
    "switch": "Mudar para Inglês"
  },
  "region": {
    "select": "Selecionar Região",
    "current": "Brasil",
    "switch": "Mudar Região"
  }
}
